export const ADD_VENDEDOR = 'channelmap/reporteconstruccion/add_vendedor';
export const RECEIVE_DATA = 'channelmap/reporteconstruccion/receive_data';
export const RECEIVE_DATA2 = 'channelmap/reporteconstruccion/receive_data2';
export const RESTART_STATE = 'channelmap/reporteconstruccion/restart_state';
export const SET_MASK = 'channelmap/reporteconstruccion/set-mask';
export const UPDATE_FIELD_FILTER = 'channelmap/reporteconstruccion/update-field-filter';
export const UPDATE_OLA_FIELD_FILTER = 'channelmap/reporteconstruccion/update-ola-field-filter';
export const UPDATE_DIST_FIELD_FILTER = 'channelmap/reporteconstruccion/update-dist-field-filter';
export const  ACTUALIZAR_MODAL = 'channelmap/reporteconstruccion/actualizar-modal';
export const  ACTUALIZAR_SUB_MODAL = 'channelmap/reporteconstruccion/actualizar-sub-modal';